// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__35WWb","default":"Badge_default__2N8sU","middle":"Badge_middle__2rpC5","top":"Badge_top__2f1bF"};